<div class="navigation-bar flex flex-between">
  <a routerLink="/" class="navigation-bar-logo flex">
    <img [src]="'img/' + page + '/logo.png'" alt="Logo" class="logo" />

    <div class="navigation-info">
      <p class="navigation-info-title">{{ "PAGE_CONFIG.TITLE" | translate }}</p>
      <p class="navigation-info-subtitle">{{ "PAGE_CONFIG.DESCRIPTION" | translate }}</p>
    </div>
  </a>

  <div class="flex">
    <div class="navigation-actions-buttons-container" *ngIf="isLogged">
      <app-navigation-cart *ngIf="isLogged"></app-navigation-cart>
    </div>

    <div class="menu-btn" (click)="toggleNav()" [class.active]="isNavOpen">
      <span></span>
    </div>
  </div>

  <div class="navigation-actions-container active" [class.active]="isNavOpen">
    <div class="navigation-membership-container flex flex-column" [ngClass]="{'disabled-becoming-member': becomingMemberDisabled}" *ngIf="appConfig.appHasMembership && (!userHasMembership || !isLogged)">
      <img [src]="'img/' + page + '/membership/nav-membership.jpg'" />
      <button
        class="btn btn-secondary"
        [disabled]="becomingMemberDisabled"
        type="button"
        (click)="openMembershipModal()"
      >
        {{ "FOOTER.BECOME_MEMBER" | translate }}
      </button>

      <span *ngIf="becomingMemberDisabled" class="tooltip-become-member">{{ "NAVIGATION.TOOLTIP_MEMBERSHIP" | translate }}</span>
    </div>

    <div class="navigation-actions" [ngClass]="{'navigation-actions-logged': isLogged}">
      <ng-container *ngIf="!isLogged; else loggedInActions">
        <div class="navigation-actions-buttons">
          <button class="btn btn-primary" type="button" (click)="modalService.openModal(modalNamesEnum.Login); isNavOpen = false">{{ "NAVIGATION.LOGIN" | translate }}</button>
          <button class="btn btn-dark" type="button" (click)="modalService.openModal(modalNamesEnum.Registration); isNavOpen = false">{{ "NAVIGATION.REGISTER" | translate }}</button>
        </div>
      </ng-container>

      <ng-template #loggedInActions>
        <div class="navigation-actions-buttons">
          <button class="btn btn-primary" type="button" (click)="changeRoute('/user-profile')">{{ "PROFILE.MY_PROFILE" | translate }}: {{ firstName }}</button>
          <button class="btn btn-primary btn-transfer"
            [disabled]="transferTicketLoading  || !hasConnectedGroupTicket || !hasGamesForDelegation"
            [ngClass]="{
              'loading': transferTicketLoading,
              'disabled-transfer-ticket': (!hasConnectedGroupTicket || !hasGamesForDelegation) && !transferTicketLoading
            }"
            type="button"
            (click)="changeRoute('/transfer-tickets')"
          >

            <span class="btn-text">{{ "COMMON.RETURN_TICKET" | translate }}</span>
            <span *ngIf="transferTicketLoading" class="spinner" aria-hidden="true"></span>
            <span *ngIf="!transferTicketLoading && !hasGamesForDelegation" class="tooltip-ticket-label">{{ "NAVIGATION.TOOLTIP" | translate }}</span>
            <span *ngIf="!transferTicketLoading && hasGamesForDelegation" class="tooltip-ticket-label">{{ "NAVIGATION.TOOLTIP_INFO" | translate }}</span>
            <span *ngIf="!transferTicketLoading && !hasConnectedGroupTicket" class="tooltip-ticket-label">
              {{ "NAVIGATION.TOOLTIP_NO_CONNECTED_GROUP_TICKET" | translate }} <br/>
              {{ "NAVIGATION.TOOLTIP_NO_CONNECTED_GROUP_TICKET_2" | translate }}
            </span>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<app-login-popup *ngIf="!isLogged && isLoginModalOpen()"></app-login-popup>
<app-forgotten-password *ngIf="!isLogged && isForgottenPassModalOpen()"></app-forgotten-password>
<app-registration *ngIf="!isLogged && isRegistrationModalOpen()"></app-registration>
<app-buy-membership *ngIf="isMembershipModalOpen()"></app-buy-membership>
